import { AlertRuleEvent } from '@/types/event';
import { PaginatedEventsResult } from './eventsDataShared';
import { UseAlertsQueryOptions, useAlertsQuery } from './useAlertsQuery';
import { usePaginatedQueryResult } from './usePaginatedQueryResult';

export type UsePaginatedAlertsOptions = UseAlertsQueryOptions;

export function usePaginatedAlerts(
    options: UsePaginatedAlertsOptions = {},
): PaginatedEventsResult<AlertRuleEvent> {
    return usePaginatedQueryResult<AlertRuleEvent>(useAlertsQuery(options));
}
